import React from 'react';
import { IconSearch, IconX } from '@tabler/icons-react';

export default function SearchField({ value, onChange, placeholder = 'Search', className = '' }) {
  return (
    <div className={`input input--search ${className}`}>
      <span className="input__addon"><IconSearch size={22} /></span>
      <input
        className="input__control"
        type="search"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        aria-label={placeholder}
      />
      {value && (
        <button type="button" className="input__addon input__addon--button" onClick={() => onChange('')} aria-label="Clear search">
          <IconX size={18} />
        </button>
      )}
    </div>
  );
}
